import { render, staticRenderFns } from "./PluginEdition.vue?vue&type=template&id=32eccfb3&"
import script from "./PluginEdition.vue?vue&type=script&lang=js&"
export * from "./PluginEdition.vue?vue&type=script&lang=js&"
import style0 from "./PluginEdition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports